module.exports = __webpack_public_path__ + "4f8599e42a769d18be8083bbd6f964bf.jpg";